import { Box, Button, Table, Text } from '@factorialco/deprecated-design-system'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

export interface ReconcilableItem {
  id: number
  bookingDate: string
  description: string
  reconcilableReconciledAmountCents: number
  reconcilableCurrency: string
  url: string
}

const ReconcilableRow = ({
  reconciliationItem,
  locale,
}: {
  reconciliationItem: ReconcilableItem
  locale: string
}) => {
  return (
    <Table.Row>
      <Table.Cell noBorder paddingX="s4">
        <Box style={{ paddingLeft: '20px' }}>
          <Text.Normal size="200">
            {dateBackendDateTimeToUI(reconciliationItem.bookingDate)}
          </Text.Normal>
        </Box>
      </Table.Cell>

      <Table.Cell noBorder paddingX="s4">
        <Box>
          <Text.Normal ellipsis size="200">
            {reconciliationItem.description}
          </Text.Normal>
        </Box>
      </Table.Cell>

      <Table.Cell noBorder paddingX="s4">
        <Box textAlign="right" maxWidth="s120">
          <Text.Normal ellipsis weight="semibold" size="200">
            {formattedAmount({
              amountCents: reconciliationItem.reconcilableReconciledAmountCents,
              currency: reconciliationItem.reconcilableCurrency,
              locale: locale,
            })}
          </Text.Normal>
        </Box>
      </Table.Cell>

      <Table.Cell noBorder paddingX="s4">
        <Box textAlign="right" maxWidth="s64">
          <Button.Router type="secondary" to={reconciliationItem.url} iconName="arrow-right" />
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default ReconcilableRow
